import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Routes from './Routes';
import TawkChat from './components/TawkChat/TawkChat';
import routeConfiguration from './routeConfiguration';
import './styles/defaults.css';

/**
 * Application root.
 *
 * The router and the Helmet context are injectable so the prerenderer can
 * render the very same tree in Node with a StaticRouter, instead of keeping
 * a second copy of this provider stack that would drift from it. The
 * browser passes nothing and gets the defaults.
 *
 * @param {object}   [props.router]       Router component (default BrowserRouter)
 * @param {object}   [props.routerProps]  Props for it, e.g. `{ location }`
 * @param {object}   [props.helmetContext] Collector react-helmet-async fills
 *   with the head tags; the server reads it after rendering.
 */
function App({ router: Router = BrowserRouter, routerProps, helmetContext }) {
  return (
    <HelmetProvider context={helmetContext}>
      <Router {...routerProps}>
        <Routes routes={routeConfiguration} />
        <TawkChat />
      </Router>
    </HelmetProvider>
  );
}

export default App;
